import { Box } from "@mui/material";
import ClientTabs from "./clientTabs";
import { BasicDropDown } from "../../../common/basicDropDown";
import { ClientContext } from "../../../context/clientContext";
import { useContext, useEffect, useState } from "react";
import { BasicButton } from "../../../common/basicButton";
import { OrganizationContext } from "../../../context/organizationContext";
import { DropDownItem } from "../../../common/dropDownItemViewModel";
import { AppUserContext } from "../../../context/appUserContext";
import { AddJobCommand, AddProductCommand, Client, EditMailingPermitCommand, FileData, PanderCountItem } from "../../../api/models/schema";
import { useApi } from "../../../hooks/useApi";
import { addClientMailingPermitApi, addClientMailOwnerPermitApi, addJobApi, addProductApi, deleteProductApi, 
         editClientMailingPermitApi, editProductApi, getClientApi, uploadPanderFileApi } from "../../../api/liveMarketingApi";
import { EditMailingPermitForm } from "../organization/editMailingPermitForm";
import { JobFormContext } from "../../../context/jobFormContext";
import { PanderFormContext } from "../../../context/panderFormContext";
import { ProductFormContext } from "../../../context/productFormContext";


export function ClientData(){

    //state
    const [selectedClient, setSelectedClient] = useState<Client | undefined>(undefined);
    const [showClientMailingPermit, setShowClientMailingPermit] = useState(false);
    const [showClientMailOwnerPermit, setShowClientMailOwnerPermit] = useState(false);
    const [mailingPermitError, setMailingPermitError] = useState('');

    const [showJobForm, setShowJobForm] = useState(false);
    const [showProductForm, setShowProductForm] = useState(false);
    const [showPanderForm, setShowPanderForm] = useState(false);

    const [panderUploadStatus, setPanderUploadStatus] = useState<PanderCountItem | undefined>(undefined);

    //context
    const { organization } = useContext(OrganizationContext);
    const { appUser } = useContext(AppUserContext);

    //api hooks
    const getClientRequest = useApi(getClientApi);
    const addClientMailingPermitRequest = useApi(addClientMailingPermitApi);
    const addClientMailOwnerPermitRequest = useApi(addClientMailOwnerPermitApi);
    const editClientMailingPermitRequest = useApi(editClientMailingPermitApi);
    const addJobRequest = useApi(addJobApi);
    const uploadPanderRequest = useApi(uploadPanderFileApi);
    const addProductRequest = useApi(addProductApi);
    const editProductRequest = useApi(editProductApi);
    const deleteProductRequest = useApi(deleteProductApi);

    //effects
    useEffect(() => {

        if (getClientRequest.data) {
          setSelectedClient(getClientRequest.data);
        }
    
      }, [getClientRequest.data]);
    
      useEffect(() => {
        if (getClientRequest.error) {
          //todo: pass the error to the correct location
        }
      }, [getClientRequest.error]);

      useEffect(() => {

        if (addClientMailingPermitRequest.data) {
          setShowClientMailingPermit(false);
            refreshPage();
        }
    
      }, [addClientMailingPermitRequest.data]);
    
      useEffect(() => {
        if (addClientMailingPermitRequest.error) {
          setMailingPermitError(addClientMailingPermitRequest.error?.message ?? 'unknown error');

        }
      }, [addClientMailingPermitRequest.error]);

      useEffect(() => {

        if (addClientMailOwnerPermitRequest.data) {
          setShowClientMailOwnerPermit(false);
            refreshPage();
        }
    
      }, [addClientMailOwnerPermitRequest.data]);
    
      useEffect(() => {
        if (addClientMailOwnerPermitRequest.error) {
          setMailingPermitError(addClientMailOwnerPermitRequest.error?.message ?? 'unknown error');

        }
      }, [addClientMailOwnerPermitRequest.error]);
    
      useEffect(() => {
    
        if (editClientMailingPermitRequest.data) {
          setShowClientMailingPermit(false);
          setShowClientMailOwnerPermit(false);
          refreshPage();
        }
    
      }, [editClientMailingPermitRequest.data]);
    
      useEffect(() => {
        if (editClientMailingPermitRequest.error) {
          setMailingPermitError(editClientMailingPermitRequest.error?.message ?? 'unknown error');
        }
      }, [editClientMailingPermitRequest.error]);
    

    

    
      //Job Effects
      useEffect(() => {
    
        if (addJobRequest.data) {
            refreshPage();
        }
    
      }, [addJobRequest.data]);

            //Pander File Effects
            useEffect(() => {
    
              if (uploadPanderRequest.data) {
                setPanderUploadStatus(uploadPanderRequest.data);
                //refreshPage();
              }
          
            }, [uploadPanderRequest.data]);
    


      const isEditPermit = selectedClient?.mailingPermit;
      const isEditMailOwner = selectedClient?.mailOwnerMailingPermit;

    //handlers

    function handleClientChange(e: React.ChangeEvent<HTMLInputElement>){
        const selectedClientId = Number(e.target.value);
        getClientRequest.request( organization?.orgId, selectedClientId, appUser?.appUserName);
    }

    function handleEditPermitClick(){
      setShowClientMailingPermit(true);
    }

    function handleEditMailOwnerClick(){
      setShowClientMailOwnerPermit(true);
    }

    function refreshHandler(){
        refreshPage();
    }

    function updateMailingPermit(editMailingPermit: EditMailingPermitCommand){

      if(!selectedClient)
        {
          //todo: display an error
          return;
        }

      if(isEditPermit && selectedClient?.mailingPermit){
        editClientMailingPermitRequest.request(organization?.orgId, selectedClient.mailingPermit.mailingPermitId, editMailingPermit, appUser?.appUserName, selectedClient.clientId, null);
      }else{
          addClientMailingPermitRequest.request(organization?.orgId, selectedClient.clientId,editMailingPermit, appUser?.appUserName);
      }
    }

    function updateMailOwnerPermit(editMailingPermit: EditMailingPermitCommand){

      if(!selectedClient)
        {
          //todo: display an error
          return;
        }

      if(isEditMailOwner && selectedClient?.mailOwnerMailingPermit){
        editClientMailingPermitRequest.request(organization?.orgId, selectedClient.mailOwnerMailingPermit.mailingPermitId, editMailingPermit, appUser?.appUserName, null, selectedClient.clientId);
      }else{
          addClientMailOwnerPermitRequest.request(organization?.orgId, selectedClient.clientId, editMailingPermit, appUser?.appUserName);
      }
    }

    function submitJobHandler(addJobCommand: AddJobCommand){
        addJobRequest.request(organization?.orgId, selectedClient?.clientId,  addJobCommand, appUser?.appUserName);
    }

    function uploadPanderFileHandler(uploadPanderFile: FileData){
        setPanderUploadStatus(undefined);
        uploadPanderRequest.request(organization?.orgId,selectedClient?.clientId, uploadPanderFile, appUser?.appUserName);
    }

    function addProductHandler(productCommand: AddProductCommand){
      addProductRequest.request(organization?.orgId, selectedClient?.clientId, productCommand, appUser?.appUserName);
    }

    function editProductHandler(productId: number, productCommand: AddProductCommand){
      editProductRequest.request(organization?.orgId, selectedClient?.clientId, productId, productCommand, appUser?.appUserName);
    }

    function deleteProductHandler(productId: number){
        deleteProductRequest.request(organization?.orgId,selectedClient?.clientId, productId, appUser?.appUserName);
    }

    //functions
    function refreshPage(){
      setShowJobForm(false);
      setShowPanderForm(false);
      setShowProductForm(false);
      getClientRequest.request(organization?.orgId, selectedClient?.clientId, appUser?.appUserName);
    }
    


    //function logic
    
    const clientList: DropDownItem[] = [];
    organization?.clients.forEach((client) => {
        clientList.push({ id: client.clientId.toString(), name: client.name });
    });

    


    
    //UI display

    function displayClientHeader(){
        return(
        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
 <BasicDropDown
   id="ddlSelectClient"
   label="select client"
   required
   width={300}
   value={selectedClient?.clientId ?? ""}
   items={clientList}
   onChange={handleClientChange}
 />

 {selectedClient && (
   <Box sx={{ display: "flex", flexDirection: "row"}}>
     <BasicButton
       labelText={`${isEditPermit ? 'edit' : 'add' } mailing permit`}
       onClick={handleEditPermitClick}
     />
   </Box>
 )}

 {selectedClient && (
   <Box sx={{ display: "flex", flexDirection: "row", marginLeft: "5px"}}>
     <BasicButton
       labelText={`${isEditMailOwner ? 'edit' : 'add' } mail owner`}
       onClick={handleEditMailOwnerClick}
     />
   </Box>
 )}
</Box>);
    }

    function displayClientTabs(){
        return(
            <Box>
            {selectedClient && <Box>
              
              <ClientTabs 
                          panderUploadStatus={panderUploadStatus}
                          onRefresh={refreshHandler} 
                          onSubmitJob={submitJobHandler} 
                          onAddPanderFile={uploadPanderFileHandler} 
                          onAddProduct={addProductHandler} 
                          onDeleteProduct={deleteProductHandler} />

              <Box>
              <EditMailingPermitForm open={showClientMailingPermit} 
                mailingPermit={selectedClient?.mailingPermit} 
                mailingPermitError={mailingPermitError}
                clientId={selectedClient?.clientId ?? ''}
                onClose={() => setShowClientMailingPermit(false)} 
                userName={appUser?.appUserName ?? ""}
                onUpdate={updateMailingPermit} />
              </Box>
              <Box>
              <EditMailingPermitForm open={showClientMailOwnerPermit} 
                mailingPermit={selectedClient?.mailOwnerMailingPermit} 
                mailingPermitError={mailingPermitError}
                mailOwnerClientId={selectedClient?.clientId ?? ''}
                onClose={() => setShowClientMailOwnerPermit(false)} 
                userName={appUser?.appUserName ?? ""}
                onUpdate={updateMailOwnerPermit} />
              </Box>
              
            </Box>
            
            }
        </Box>

        );

    }

    return (
        <ClientContext.Provider value={
          {
            client:selectedClient,
            addJob:submitJobHandler,
            uploadPanderFile:uploadPanderFileHandler,
            addProduct:addProductHandler,
            editProduct:editProductHandler,
            deleteProduct:deleteProductHandler
            }}>

            {displayClientHeader()}

            <JobFormContext.Provider value={
             { isLoading: addJobRequest.loading,showForm: showJobForm,errorMessage: addJobRequest.error?.message ?? '', 
             openForm: () => setShowJobForm(true),closeForm: () => setShowJobForm(false)}}>

            <PanderFormContext.Provider value={
             { isLoading: uploadPanderRequest.loading,showForm: showPanderForm,errorMessage: uploadPanderRequest.error?.message ?? '', 
             openForm: () => setShowPanderForm(true), closeForm: () => setShowPanderForm(false)}}>

            {displayClientTabs()}

            
            </PanderFormContext.Provider>
            </JobFormContext.Provider>

        </ClientContext.Provider>
    );
}